import { fonts, palette, radius } from "@kashmere/core";
import { KashmereCard, ProductLockup } from "./kashmere";

// #295 — apps/aten is the Atén landing page. The household's Atén information is
// presented in the Kashmere app (the Esqé SPA at app.kashmere.ai); there is no
// separate family-facing Atén dashboard. This page says so, sends the household
// there, and keeps the partner-facing hardware guide (public/hardware) one click away.
// Every value is a design token (ADR-0009); no colour or family is declared here.

const linkBase = {
  display: "inline-flex",
  alignItems: "center",
  gap: 8,
  padding: "12px 20px",
  borderRadius: `${radius.buttonLg}px`,
  fontFamily: fonts.mono,
  fontWeight: 500,
  fontSize: 11,
  letterSpacing: "2px",
  textTransform: "uppercase",
  textDecoration: "none",
  transition: "box-shadow 0.2s ease, transform 0.15s ease",
};

const primaryLink = { ...linkBase, background: palette.teal.base, color: palette.teal.ink };
const outlineLink = { ...linkBase, background: "transparent", color: palette.teal.base, border: `1px solid ${palette.teal.base}` };

export default function App() {
  return (
    <main style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <KashmereCard style={{ maxWidth: 560, width: "100%", padding: "40px 36px" }}>
        <ProductLockup product="aten" size="lg" />
        <h1 style={{ fontFamily: fonts.serif, fontWeight: 300, fontSize: 32, lineHeight: 1.15, margin: "28px 0 12px", color: palette.text.cream }}>
          Your household&rsquo;s companion is set up.
        </h1>
        <p style={{ fontFamily: fonts.sans, fontWeight: 300, fontSize: 16, lineHeight: 1.6, margin: "0 0 28px", color: palette.text.secondary }}>
          Everything Atén knows about your household is presented in the Kashmere app, alongside the rest of your estate. Sign in there to see it.
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
          <a href="https://app.kashmere.ai" style={primaryLink}>Open the Kashmere app</a>
          <a href="/hardware/index.html" style={outlineLink}>Hardware guide</a>
        </div>
        <p style={{ fontFamily: fonts.sans, fontWeight: 300, fontSize: 13, lineHeight: 1.5, margin: "28px 0 0", color: palette.text.dim }}>
          The hardware guide is for the partner who installs and maintains the appliance.
        </p>
      </KashmereCard>
    </main>
  );
}
